export const APPLICATION_URL = "https://igm.clouddeploy.in/";
export const API_BASE_PATH = "api/v1";

export const API_BASE_URL = `${APPLICATION_URL}${API_BASE_PATH}`;

export const endpoint = {
  GET_ANALYTICS: `${API_BASE_URL}/issues/analytics`,
  GET_ORDERS: `${API_BASE_URL}/orders/getOrders`,
  GET_ORDER_DETAIL: `${API_BASE_URL}/orders/getOrderDetails`,
  GET_ISSUES: `${API_BASE_URL}/issues/getList`,
  GET_ISSUE_DETAILS: `${API_BASE_URL}/issues/getIssueDetails`,
  REQUEST_INFO: `${API_BASE_URL}/issues/requestInfo`,
  PROVIDE_RESOLUTION: `${API_BASE_URL}/issues/issueResolution`,
  GET_GRIEVANCES: `${API_BASE_URL}/issues/getList`,
  RESPOND_TO_RESOLUTION: `${API_BASE_URL}/issues/respondToResolution`,
  PROVIDE_INFO: `${API_BASE_URL}/issues/provideInfo`,
  ESCALATE_ISSUE: `${API_BASE_URL}/issues/escalateIssue`,
  RAISE_ISSUE: `${API_BASE_URL}/issues/raiseIssue`,
  CLOSE_ISSUE: `${API_BASE_URL}/issues/close`,
  RESOLVE_ISSUE: `${API_BASE_URL}/issues/resolveIssue`,
  CONTACT_US:`${API_BASE_URL}/support/contact_us`,
  GET_FAQS:`${API_BASE_URL}/support/faqs`,
  REQUEST_STATUS:`${API_BASE_URL}/issues/requestStatus`
};
